import { useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchFromApi } from 'api/apiClient';
import { UploadLocationImageResponse } from 'types/organizationTypes';
import { FOLDER_ORGANIZATIONS_EUDR_DOCUMENTS } from 'utils/eudrCommon';

// Base API URL

const REACT_APP_DARWIN_URL = import.meta.env.VITE_DARWIN_URL;

// Query keys
const EUDR_DOCS_QUERY_KEY = 'eudr_docs';
export const SINGLE_ORGANIZATION_QUERY_KEY = 'eudr_organization';

/**
 * Upload EUDR Docs
 */
export const useUploadEUDRDocs = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      file,
      folder = FOLDER_ORGANIZATIONS_EUDR_DOCUMENTS,
    }: {
      file: File;
      folder?: string;
    }) => {
      const formData = new FormData();
      formData.append('file', file);

      return fetchFromApi<UploadLocationImageResponse>(
        `${REACT_APP_DARWIN_URL}/files/upload/${folder}`,
        {
          method: 'POST',
          body: formData,
        }
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EUDR_DOCS_QUERY_KEY] });
    },
  });
};

/**
 * Delete EUDR Doc by FieldID
 */

export const useDeleteEUDRDocByFieldId = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      fieldId,
      companyId,
      targetCompanyId,
    }: {
      fieldId: string;
      companyId: string;
      targetCompanyId: string;
    }) =>
      fetchFromApi(
        `${REACT_APP_DARWIN_URL}/companies/${companyId}/target-company/${targetCompanyId}/eudr-files/${fieldId}`,
        {
          method: 'DELETE',
        }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SINGLE_ORGANIZATION_QUERY_KEY],
      });
    },
  });
};
